/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable sonarjs/prefer-immediate-return */
/* eslint-disable sonarjs/no-duplicate-string */
import { makeStyles, RACCOLOR } from '@rentacenter/racstrap';
export const localSourcingStyles = () => {
  const useClasses = makeStyles((theme) => ({
    dialogActions: {},
    dialogTitle: {
      lineHeight: '40px',
      // backgroundColor: '#77FFFF',
      fontSize: '1.5rem important!',
    },
    addProductLink: {
      color: '#2179FE',
      fontSize: theme.typography.pxToRem(14),
      cursor: 'pointer',
      width: '100%',
      fontFamily: 'OpenSans-semibold',
      textAlign: 'right',
      verticalAlign: 'bottom',
      textDecoration: 'underline !important',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      // backgroundColor: '#77FF77',
    },

    removeProductLink: {
      color: '#2179FE',
      fontSize: theme.typography.pxToRem(14),
      cursor: 'pointer',
      width: '100%',
      fontFamily: 'OpenSans-semibold',
      textAlign: 'right',
      verticalAlign: 'top',
      alignItems: 'top',
      textDecoration: 'underline !important',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      // backgroundColor: '#77FF77',
    },
    removeDivStyle: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      width: '100%',
    },
    buttongrid: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.typography.pxToRem(20),
      // backgroundColor: '#772177',
    },

    addLinkDisabled: {
      color: '#777777',
      // color: '#e9ecef',
      fontSize: theme.typography.pxToRem(14),
      cursor: 'pointer',
      width: '100%',
      fontFamily: 'OpenSans-semibold',
      textAlign: 'right',
      verticalAlign: 'bottom',
      textDecoration: 'underline !important',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },

    dialogRoot: {
      backgroundColor: '#777777',
      paddingTop: '-100px',
      height: 'auto',
      '& .MuiPaper-rounded': {
        borderRadius: theme.typography.pxToRem(12),
      },
      '& .MuiDialog-paperWidthXs': {
        maxWidth: theme.typography.pxToRem(777),
      },
      '& .MuiTypography-h5': {
        fontSize: theme.typography.pxToRem(20),
        fontWeight: 500,
        lineHeight: theme.typography.pxToRem(30),
      },
    },
    dialogContent: {
      margin: `2rem 0`,
      marginTop: '-20px',
      // backgroundColor: '#7777FF',
      height: 'auto',
    },
    shopLocalsRoot: {
      width: '100%',
      minWidth: '650px',
      display: 'flex',
      flexDirection: 'column',
      // backgroundColor: '#FF7777',
      height: 'auto',
      margin: 0,
      padding: 0,
    },
    shopLocalHeader: {
      paddingBottom: '20px',
      fontSize: '1.125rem',
    },
    fullItem: {
      fontSize: '1rem',
      width: '100%',
      fontWeight: 200,
      lineHeight: 1.235,
      letterSpacing: '.007535em',
      // backgroundColor: '#5ea0d6',
    },
    labelHeader: {
      fontSize: '1rem',
      fontWeight: 200,
      lineHeight: 1.235,
      letterSpacing: '.007535em',
    },
    grid: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: theme.typography.pxToRem(20),
      // backgroundColor: '#772177',
    },
    spacingItem: {
      minHeight: '20px',
    },
    labelGroup: {
      padding: '20px',
      minWidth: '200px',
      fontSize: '1.25rem',
      fontWeight: 300,
      marginLeft: 0,
      paddingLeft: 0,
      lineHeight: 1.235,
      // backgroundColor: '#77F1FE',
      letterSpacing: '.007535em',
    },
    productdetailsgrid: {
      width: '55%',
      minWidth: '440px',
    },
    productdetailSmallgrid: {
      width: 'auto',
      minWidth: '100px',
      overflow: 'hidden',
    },
    pdsg: {
      width: 'auto',
      minWidth: '150px',
      overflow: 'hidden',
      // backgroundColor: '#772121',
    },
    comboStyle: {
      width: '200px',
      minWidth: '200px',
    },
    loadingprogres: {
      minHeight: '60vh',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // backgroundColor: '#777777',
    },
    colorit: {
      backgroundColor: '#777777',
    },
    productspecial: {
      width: '120px',
      minWidth: '120px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // backgroundColor: '#18FFFE',
    },
    productdetailMidgrid: {
      width: '80px',
      minWidth: '80px',
      overflow: 'hidden',
    },
    errorstyle: {
      fontFamily: 'OpenSans-semibold',
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(14),
      color: RACCOLOR.MAXIMUM_RED,
      margin: 0,
      padding: 0,
    },
    label: {
      fontFamily: 'OpenSans-semibold',
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(14),
      color: RACCOLOR.BLUE_CRAYOLA,
      margin: 0,
      padding: 0,
    },
    divideStyle: {
      fontSize: theme.typography.pxToRem(24),
      color: RACCOLOR.DEEP_SKY_BLUE,
      width: '100%',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    answergrid: {
      marginTop: 5,
      marginBottom: 5,
      padding: 0,
    },
    card: {
      marginTop: '40px',
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'flex-end',
      bottom: 0,
      backgroundColor: '#E8F1FE',
    },
    cardBody: {
      flex: '1 1 auto',
    },
  }));

  const classes = useClasses();

  return classes;
};
